import { CustomRoutes, Resource } from "react-admin";
import { Route } from "react-router-dom";
import { FdbDashboard } from "./resources/fdb/FdbDashboard";
import { FdbGameConfigs } from "./resources/fdb/FdbGameConfigs";
import { FdbRoundShow } from "./resources/fdb/FdbRoundShow";
import { BetList } from "./resources/oracle/BetList";
import { BetShow } from "./resources/oracle/BetShow";
import { GameConfigList } from "./resources/oracle/GameConfigList";
import { OperatorList } from "./resources/oracle/OperatorList";
import { OperatorStatsPage } from "./resources/oracle/OperatorStatsPage";
import { RoundList } from "./resources/oracle/RoundList";
import { RoundShow } from "./resources/oracle/RoundShow";
import { UserList } from "./resources/oracle/UserList";
import { WalletRequestList } from "./resources/oracle/WalletRequestList";
import { ReconPage } from "./resources/recon/ReconPage";

// Keep Resource elements directly visible to Admin's resource registration.
export const crashResources = [
  <Resource
    key="crash/db-rounds"
    name="crash/db-rounds"
    list={RoundList}
    show={RoundShow}
    options={{ label: "Rounds" }}
  />,
  <Resource
    key="crash/db-bets"
    name="crash/db-bets"
    list={BetList}
    show={BetShow}
    options={{ label: "Bets" }}
  />,
  <Resource
    key="crash/db-wallet-requests"
    name="crash/db-wallet-requests"
    list={WalletRequestList}
    options={{ label: "Wallet Requests" }}
  />,
  <Resource
    key="crash/db-users"
    name="crash/db-users"
    list={UserList}
    options={{ label: "Users" }}
  />,
  <Resource
    key="crash/db-operators"
    name="crash/db-operators"
    list={OperatorList}
    options={{ label: "Operators" }}
  />,
  <Resource
    key="crash/db-game-configs"
    name="crash/db-game-configs"
    list={GameConfigList}
    options={{ label: "Game Configs" }}
  />,
  <CustomRoutes key="crash/routes">
    <Route path="/crash/fdb" element={<FdbDashboard />} />
    <Route path="/crash/fdb/rounds/:roundId" element={<FdbRoundShow />} />
    <Route path="/crash/fdb/game-configs" element={<FdbGameConfigs />} />
    <Route path="/crash/recon" element={<ReconPage />} />
    <Route path="/crash/operator-stats" element={<OperatorStatsPage />} />
  </CustomRoutes>,
];
